export default __webpack_public_path__ + "static/media/in_active_icon.f21b228f.svg";